import { lazy } from "react"; //insures components are loaded correctly as actual React components rather than Promises.
import config from './config.js'

const routes =[
    {
        path: '/',
        name: "Incident Form",
        component: lazy(() => import("./incidentForm/VehicleIncident"))
      },
      {
        path: "/login",
        name: "Login",
        component: lazy(() => import("./LoginComponent"))
      }
];

export default routes;
